import React from 'react';

import { Typography, Divider, StackView } from '@telus-uds/components-web';


import { Container } from './styles';
import Form from '../form/fields/defectManagementFields/index';

import DefectManagement from '../defectManagement';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';

const ReportAnIssue = () => {
  const locale = useLocaleContext();
  const {
    DEFECT_MANAGEMENT: { TITLE }
  } = locale === 'en-US' ? EN : FR;

  return (
    <>
      <div className="container 85% report-an-issue">
        <Container>
          <StackView space={4}>
            <Typography heading="h2" variant={{ size: 'h2' }} block>{TITLE}</Typography>
            <Divider />
            <Form />
          </StackView>
        </Container>
      </div>
      <Divider space={6} variant={{ inverse: true }}/>
      <DefectManagement />
    </>
  );
};

export default ReportAnIssue;

